import { Component, Input, ViewChild } from '@angular/core';
import { BarChartComponent } from "../../charts/bar-chart.component";
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-classroom-syllabus-card',
  standalone: true,
  imports: [BarChartComponent, CommonModule],
  templateUrl: './classroom-syllabus-card.component.html',
  styleUrl: './classroom-syllabus-card.component.scss'
})
export class ClassroomSyllabusCardComponent {
  @Input() filter: boolean = false;
 
}
